//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import ReplacementCodes from "@/pages/ProductManagement/components/replacementCodesTable.vue";

const EMPTY_LINE = {
  code: null,
  origin: null,
  date: null
};

export default {
  name: "BusinessTab",
  props: ["value"],
  components: {
    ReplacementCodes
  },
  mounted: function() {
    BackendServices.getRetailers().then(
      response => {
        this.retailers = response.data
        this.formOpen = Array(this.value.product_codes.length).fill(false)
      }
    );
  }, 
  data: () => ({
    tab: "traits",
    retailers: [],
    code: {},
    formOpen: [],
    popupForm: EMPTY_LINE
  }),
  methods: {
    updateData() {
      this.$emit("value", this.value);
    },
    retailerInfoForRetailer: function(retailerId) {
      return this.value.product_retailer_infos.filter(
        retailerInfo => retailerInfo.retailer_id === retailerId
      )[0];
    },
    replacementCodesForRetailer(retailer) {
      return this.value.product_codes.filter(i => i.retailer_id === retailer.id)
    },
    updateCode: function(event) {
      let index = this.value.product_codes.map( (i) => (i.id)).indexOf(event.id);
      this.value.product_codes.splice(index, 1, event);
      this.updateData();
    },
  },
  computed: {
    retailersForProduct: function() {
      return this.retailers.filter(
        retailer =>
          this.value.product_retailer_infos.filter(
            retailerInfo => retailerInfo.retailer_id === retailer.id
          ).length > 0
      );
    }
  }
};
